import {
  fetchActiveRequestForRegister,
  fetchActiveRequestLoadSummaries,
} from './kioskApi';
import { OPEN_LOAD_STATUSES } from './kioskConstants';
import {
  deriveRequestLoadStatus,
  mergeReadings,
  mergeRequestLoad,
  mergeRequests,
  normalizeReading,
  normalizeRequest,
  normalizeRequestLoad,
} from './kioskTransforms';
import { useKioskHub } from '../useKioskHub';

export function useKioskRealtime({
  currentRequest,
  refreshVisibleData,
  selectedRegisterId,
  setConnectionStatus,
  setCurrentRequest,
  setCurrentRequestLoad,
  setReadings,
  setReadingsState,
  setRequestLoads,
  setRequestState,
  setRequests,
  setSelectedRequestLoadId,
}) {
  useKioskHub({
    registerId: selectedRegisterId,
    onRequestUpdated: (updatedRequest) => {
      if (!updatedRequest || updatedRequest.registerId !== selectedRegisterId) {
        return;
      }

      const normalizedRequest = normalizeRequest(updatedRequest);
      setRequests((currentItems) => mergeRequests(currentItems, normalizedRequest));

      if (
        normalizedRequest.confirmationStatus === 'Confirmed'
        || normalizedRequest.confirmationStatus === 'Rejected'
      ) {
        if (currentRequest?.requestId === normalizedRequest.requestId) {
          fetchActiveRequestForRegister(selectedRegisterId)
            .then((nextRequest) => {
              if (nextRequest) {
                setCurrentRequest(nextRequest);
                setRequests((items) => mergeRequests(items, nextRequest));
                setReadings([]);
              }
            })
            .catch(() => {});
        }
        return;
      }

      setCurrentRequest((current) => {
        if (
          current?.requestId !== normalizedRequest.requestId
          || current?.replacesRequestId !== normalizedRequest.replacesRequestId
        ) {
          setReadings([]);
        }

        return normalizedRequest;
      });
      setRequestState({ type: 'success', message: '' });
    },
    onReadingReceived: (reading) => {
      const normalizedReading = normalizeReading(reading);
      if (!normalizedReading) {
        return;
      }

      const matchesRequest = normalizedReading.requestId === currentRequest?.requestId
        || normalizedReading.requestId === currentRequest?.readingsSourceRequestId;
      if (!matchesRequest) {
        return;
      }

      setReadings((currentItems) => mergeReadings(currentItems, normalizedReading));
      setReadingsState({ type: 'success', message: '' });
    },
    onLoadUpdated: (load) => {
      const normalizedLoad = normalizeRequestLoad(load);
      if (!normalizedLoad?.loadId) {
        return;
      }

      setRequestLoads((currentItems) => mergeRequestLoad(currentItems, normalizedLoad));

      if (!normalizedLoad.aggregate) {
        fetchActiveRequestLoadSummaries()
          .then(setRequestLoads)
          .catch(() => {});
      }

      if (!OPEN_LOAD_STATUSES.has(deriveRequestLoadStatus(normalizedLoad))) {
        setCurrentRequestLoad((current) => (current?.loadId === normalizedLoad.loadId ? null : current));
        setSelectedRequestLoadId((current) => (current === normalizedLoad.loadId ? '' : current));
      }
    },
    onReconnected: refreshVisibleData,
    onConnectionStateChange: setConnectionStatus,
  });
}
